module.exports = __webpack_public_path__ + "static/image2-e25bce3e15f8a505dc0572e569443359.jpg";